module.exports = __webpack_public_path__ + "media/images/coin@2x-522c3ea13b6261745f26e9ef113f2e08.png";